import React, { useState, useEffect, useCallback } from 'react';
import { FaHome, FaStore, FaStar, FaQuestionCircle, FaEnvelope } from "react-icons/fa";

const NAV_LINKS = [
  { label: 'Inicio', page: 'home', icon: <FaHome /> },
  { label: 'Tienda', page: 'shop', icon: <FaStore /> },
  { label: 'Novedades', page: 'news', icon: <FaStar /> },
  { label: 'Preguntas Frecuentes', page: 'faq', icon: <FaQuestionCircle /> },
  { label: 'Contacto', page: 'contact', icon: <FaEnvelope /> },
];

const LayoutHeader = ({ onNavigate }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  // Abre el menú y mete una entrada en el historial
  const openMenu = useCallback(() => {
    setMenuOpen(true);
    window.history.pushState({ menu: true }, ''); // añade entrada al historial
  }, []);

  // Cierra el menú y si está en el historial, regresa
  const closeMenu = useCallback(() => {
    setMenuOpen(false);
    if (window.history.state && window.history.state.menu) {
      window.history.back();
    }
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const onPopState = () => {
      setMenuOpen(false);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, [menuOpen]);

  const handleNav = (page) => {
    setMenuOpen(false); // Cierra menú al navegar
    onNavigate(page);
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white/30 backdrop-blur-md border-b border-white/20 shadow-lg p-4 flex justify-between items-center transition-all duration-300">
      <div className="text-2xl md:text-4xl font-display font-extrabold text-primary drop-shadow-md tracking-tight">
        Atlantis Fish <span className="text-waterBlue">🐟</span>
      </div>

      {/* Menú desktop */}
      <nav className="hidden md:flex space-x-6">
        {NAV_LINKS.map(({ label, page }) => (
          <button
            key={page}
            onClick={() => onNavigate(page)}
            className="px-4 py-2 rounded-xl font-semibold text-deepBlue bg-white/30 backdrop-blur-md hover:bg-primary/20 hover:text-primary transition-all duration-200 shadow-sm"
          >
            {label}
          </button>
        ))}
      </nav>

      {/* Carrito + Hamburguesa */}
      <div className="flex items-center space-x-2 md:space-x-4">
        <button
          onClick={() => onNavigate('cart')}
          className="text-primary hover:text-accent bg-white/70 rounded-full p-2 shadow-md transition-all relative backdrop-blur-sm"
        >
          {/* Ícono de carrito */}
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </button>
        {/* Menú hamburguesa SOLO en móvil */}
<button
  className="md:hidden text-waterBlue hover:text-primary rounded-full p-2 transition"
  onClick={openMenu}        >
          <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>

      {/* Drawer del menú mobile */}
      {menuOpen && (
<div
  className="fixed inset-0 z-50 bg-black bg-opacity-40 flex md:hidden items-start justify-center pt-8"
  onClick={closeMenu}        >
          <div
            className="bg-white w-11/12 max-w-xs mx-auto rounded-xl shadow-2xl p-5 flex flex-col gap-2 animate-slideInLeft"
            onClick={e => e.stopPropagation()}
          >
            <div className="flex flex-col items-center mb-2 mt-1">
              <img src="/atlantis.png" className="w-12 h-12 mb-1" alt="Atlantis Fish logo" />
              <span className="font-bold text-primary text-lg">Atlantis Fish</span>
            </div>

  <button
    className="self-end mt-1 mb-2 mr-1 text-gray-500 hover:text-red-500 text-4xl"
    onClick={closeMenu}
    aria-label="Cerrar menú"
  >
    &times;
  </button>            {NAV_LINKS.map(({ label, page, icon }, idx) => (
              <button
                key={page}
                onClick={() => handleNav(page)}
                className={`w-full flex items-center text-left py-3 px-4 rounded-lg text-deepBlue font-semibold hover:bg-primary/10 transition text-lg ${
                  idx < NAV_LINKS.length - 1 ? 'border-b border-gray-100' : ''
                }`}
              >
                <span className="text-xl mr-3">{icon}</span>
                {label}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Animación para drawer (agrega esto a tu Tailwind si quieres) */}
      <style>{`
        @keyframes slideInLeft {
          from { transform: translateX(-100%);}
          to { transform: translateX(0);}
        }
        .animate-slideInLeft {
          animation: slideInLeft 0.25s cubic-bezier(.4,0,.2,1) both;
        }
      `}</style>
    </header>
  );
};

export default LayoutHeader;
